import { createContext } from "react";

const adminRegistrationContext = createContext();

export default adminRegistrationContext;
